<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="goBack"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 申请信息 -->
    <el-descriptions border column="3" title="申请信息">
      <el-descriptions-item label="申请人">{{
        detail.applyName
      }}</el-descriptions-item>
      <el-descriptions-item label="水卡编号">{{
        detail.waterCard
      }}</el-descriptions-item>
      <el-descriptions-item label="水卡类型">{{
        detail.cardType == 1
          ? "电子卡"
          : detail.cardType == 2
          ? "实物卡"
          : detail.cardType == 3
          ? "时效电子卡"
          : detail.cardType == 4
          ? "时效实物卡"
          : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="是否绑定">
        {{ detail.userId ? "已绑定" : "未绑定" }}
      </el-descriptions-item>
      <el-descriptions-item label="用户电话">{{
        detail.phone ? detail.phone : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="申请备注">{{
        detail.applyMsg
      }}</el-descriptions-item>
      <el-descriptions-item label="申请图片">
        <div v-if="detail.applyImgList">
          <el-image
            v-for="(url, index) in detail.applyImgList"
            :key="index"
            class="mgr-10"
            style="width: 100px; height: 100px"
            :src="url"
            :preview-src-list="detail.applyImgList"
          >
          </el-image>
        </div>
        <span v-else>- -</span>
      </el-descriptions-item>

      <!-- <el-descriptions-item label="归属企业">{{
        detail.companyName
      }}</el-descriptions-item> -->
      <el-descriptions-item label="所属分区">{{
        detail.regionName
      }}</el-descriptions-item>
      <el-descriptions-item label="申请时间">{{
        detail.applyTime
      }}</el-descriptions-item>
    </el-descriptions>





    <!-- 初审信息 -->




    <el-descriptions border column="2" title="审核信息">
      <el-descriptions-item label="审核状态">{{
        // detail.state == 1 ? "待审核" : detail.state == 5 ? "已驳回" : "已通过"
        detail.state == 5
            ? "- -"
            : detail.state == 6
            ? "- -"
            : detail.state == 7
            ? "已驳回"
            : detail.state == 4
            ? "已通过"
            : "待审核"
      }}</el-descriptions-item>
      <el-descriptions-item label="审核人">{{
        detail.checkFinalName ? detail.checkFinalName : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="审核时间">{{
        detail.checkFinalTime ? detail.checkFinalTime : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="审核备注">{{
        detail.checkFinalMsg ? detail.checkFinalMsg : "- -"
      }}</el-descriptions-item>
    </el-descriptions>
    <!-- 复审信息 -->
    <!-- <el-descriptions
      border
      column="2"
      title="复审信息"
      v-if="detail.checkFirstTime && detail.state !== 5"
    >
      <el-descriptions-item label="复审状态">
        {{
          detail.state == 5
            ? "- -"
            : detail.state == 3
            ? "已通过"
            : detail.state == 4
            ? "已通过"
            : detail.state == 7
            ? "已通过"
            : detail.state == 6
            ? "已驳回"
            : "待审核"
        }}</el-descriptions-item
      >
      <el-descriptions-item label="审核人">{{
        detail.reexamineName ? detail.reexamineName : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="复审时间">{{
        detail.reexamineTime ? detail.reexamineTime : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="复审备注">{{
        detail.reexamineMsg ? detail.reexamineMsg : "- -"
      }}</el-descriptions-item>
    </el-descriptions> -->
    <!-- 终审信息 -->
    <!-- <el-descriptions
      border
      column="2"
      title="终审信息"
      v-if="detail.reexamineTime && detail.state !== 6"
    >
      <el-descriptions-item label="终审状态">
        {{
          detail.state == 5
            ? "- -"
            : detail.state == 6
            ? "- -"
            : detail.state == 7
            ? "已驳回"
            : detail.state == 4
            ? "已通过"
            : "待审核"
        }}
      </el-descriptions-item>
      <el-descriptions-item label="审核人">{{
        detail.checkFinalName ? detail.checkFinalName : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="终审时间">{{
        detail.checkFinalTime ? detail.checkFinalTime : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="终审备注">{{
        detail.checkFinalMsg ? detail.checkFinalMsg : "- -"
      }}</el-descriptions-item>
    </el-descriptions> -->
    <!-- 清零信息 -->
    <el-descriptions
      border
      column="3"
      title="清零信息"
      v-if="detail.state == 4"
    >
      <el-descriptions-item label="水卡清零（扣减余额）订单编号">{{
        detail.orderNo
      }}</el-descriptions-item>
      <el-descriptions-item label="清零总金额（赠送/实付）">{{
        detail.resetPrice +
          "（" +
          detail.givePrice +
          "/" +
          detail.payPrice +
          "）"
      }}</el-descriptions-item>
      <el-descriptions-item label="清零时间">{{
        detail.resetTime
      }}</el-descriptions-item>
    </el-descriptions>
    <!-- 电子审批凭证 -->
    <!-- <el-descriptions
      border
      column="1"
      title="电子审批凭证"
      v-if="detail.state == 4"
    >
      <el-descriptions-item label="操作">
        <el-button type="primary" @click="handleCheckProof">查看凭证</el-button>
      </el-descriptions-item>
    </el-descriptions> -->
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      id: null,
      type: null,
      detail: null,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.laiyuan = this.$route.query.laiyuan;
    this.getDetail();
  },
  methods: {
    // 详情
    getDetail() {
      this.$api.waterCard
        .cardClearZeroDetail({ id: Number(this.id) })
        .then((res) => {
          if (res.code == 200) {
            this.detail = res.data;
          }
        });
    },
    handleCheckProof() {
      this.$router.push({
        path: "/cardClearZero/detail/checkProof",
        query: {
          id: this.id,
          type: this.type,
          data: this.detail,
        },
      });
    },
    goBack() {
      this.$router.push(
        `${
          this.laiyuan == 'sellFirst'
          ? "/cardClearZero/sellFirst":
          this.laiyuan == 'applyForRecord'
          ? "/cardClearZero/applyForRecord":
          this.laiyuan == 'financeAgain'
          ? "/cardClearZero/financeAgain":
          this.laiyuan == 'financeEnd'
          ? "/cardClearZero/financeEnd":
          ""
        }`
      );
      // this.$router.push('/cardClearZero/applyForRecord')
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-descriptions__title {
  color: var(--accent) !important;
  margin-top: 10px;
}
</style>
